/* @flow */

import React from 'react';
import Responsive from 'app/components/responsive/Responsive';
import AdvertSlot from 'app/components/commons/AdvertSlot';

type AdvertItem = {
  screenModes: Array<string>,
  slot: {
    id: string,
    height: number,
    path: string,
    width: number,
  },
};

type Props = {
  className?: string,
  items: Array<AdvertItem>,
};

const defaultProps = {
  className: undefined,
};

function Advert({
  className,
  items,
}: Props) {
  return (
    <div>
      {items.map(({ screenModes, slot }) => (
        <Responsive
          key={slot.id}
          mobile={screenModes.includes('mobile')}
          tabletPortrait={screenModes.includes('tabletPortrait')}
          tabletLandscape={screenModes.includes('tabletLandscape')}
          desktop={screenModes.includes('desktop')}
          desktopLarge={screenModes.includes('desktopLarge')}
        >
          <div className={className}>
            <AdvertSlot
              id={slot.id}
              height={slot.height}
              width={slot.width}
            />
          </div>
        </Responsive>
      ))}
    </div>
  );
}

Advert.defaultProps = defaultProps;

export default Advert;
